import { t } from "i18next"
import { makeAutoObservable, runInAction } from "mobx"
import { FIRESTORE_COLLECTIONS } from "../enums"
import { IEventCollectionItem, IParticipatedEventItem, ISuccessParams } from "../interfaces"
import FirebaseMapper from "../mappers/FirebaseMapper"
import Firestore from "../services/FirestoreService"
import AuthStore from "./AuthStore"

export class ScanStore {
	public isLoading = false
	public enabled = true
	public error: Error | null = null

	constructor() {
		makeAutoObservable(this)
	}

	public async scan(data: string): Promise<ISuccessParams | null> {
		if (!AuthStore.user) {
			return null
		}

		this.isLoading = true
		this.enabled = false
		this.error = null

		let event: null | IEventCollectionItem = null
		let error: Error | null = null

		const userEvents = AuthStore.user.events

		try {
			event = await Firestore.get<IEventCollectionItem>(FIRESTORE_COLLECTIONS.EVENTS_COLLECTION, data)
		} catch (err) {
			error = err as Error
		}

		if (event) {
			const participatedEvent = FirebaseMapper.mapEventToUserParticipatedEvent(event)
			const alreadyScanned = userEvents.find((e) => e.id === participatedEvent.id) !== undefined

			try {
				Firestore.pushToArray<IParticipatedEventItem>(
					FIRESTORE_COLLECTIONS.USER_COLLECTION,
					AuthStore.user.userId,
					"events",
					participatedEvent,
				)

				if (!alreadyScanned) {
					runInAction(() => {
						userEvents.push(participatedEvent)
					})
				}
			} catch (err) {
				error = err as Error
			}

			const successParams: ISuccessParams = {
				title: alreadyScanned ? t("success.already_scanned") : t("success.congratulations"),
				text: alreadyScanned ? undefined : t("success.received_new_badge"),
				image: event.ticketImage,
				redirect: { to: "/", delay: 5 },
			}

			runInAction(() => {
				this.error = error
				this.isLoading = false
			})

			return successParams
		}

		runInAction(() => {
			this.error = error
			this.isLoading = false
		})

		return null
	}

	public enable() {
		this.enabled = true
	}
}
